import {
  type ComponentPropsWithoutRef,
  type PropsWithChildren,
  memo,
  useCallback,
} from "react";

import { Splide, type SplideProps, SplideSlide } from "@splidejs/react-splide";
import type { Splide as SplideInstance } from "@splidejs/splide";

import "@splidejs/splide/css/core";

type CarouselProps = PropsWithChildren & SplideProps;

const CarouselBase = ({ children, ...splideProps }: CarouselProps) => {
  const removeAriaRoles = useCallback((splide: SplideInstance) => {
    queueMicrotask(() => {
      const { list, slides } = splide.Components.Elements;
      list.removeAttribute("role");
      slides.forEach((slide) => slide.removeAttribute("role"));
    });
  }, []);

  return (
    <Splide
      {...splideProps}
      onMounted={removeAriaRoles}
      onRefresh={removeAriaRoles}
    >
      {children}
    </Splide>
  );
};

export const Carousel = memo(CarouselBase);

type SlideProps = PropsWithChildren &
  ComponentPropsWithoutRef<typeof SplideSlide>;

const SlideBase = ({ children, ...splideProps }: SlideProps) => {
  return <SplideSlide {...splideProps}>{children}</SplideSlide>;
};

export const Slide = memo(SlideBase);
export { SplideTrack as Track } from "@splidejs/react-splide";
export { CarouselArrows } from "@react/components/Carousel/CarouselArrows.view";
export { CarouselArrow } from "@react/components/Carousel/CarouselArrow.view";
export {
  CarouselPaginationDots,
  onPaginationUpdated,
} from "@react/components/Carousel/CarouselPaginationDots.view";
